import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Head tags written into the HTML at build time (scripts/prerender.js). React
// renders the same tags itself, so drop these first to avoid duplicates.
document.querySelectorAll("head [data-prerender]").forEach((el) => el.remove());

// Prerendered pages already contain the markup React's first render produces,
// so React adopts it (hydrateRoot) instead of rebuilding it. Any mismatch makes
// React fall back to a full client render, which is safe.
const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
if (container.hasChildNodes()) {
  // The entrance animations already ran on the prerendered markup; don't replay
  // them if React has to re-render (see .prerendered in index.css).
  document.documentElement.classList.add("prerendered");
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
